type MeterErrorBody = {
  message?: unknown
  errors?: { authorizations?: unknown }
}

export const meterErrorMessage = (error: unknown, fallback: string): string => {
  if (typeof error === 'string') {
    return error !== '' ? error : fallback
  }
  if (!error || typeof error !== 'object') {
    return fallback
  }

  const { message, errors } = error as MeterErrorBody
  const authorizations = errors?.authorizations
  if (Array.isArray(authorizations) && typeof authorizations[0] === 'string') {
    return authorizations[0]
  }
  if (typeof message === 'string' && message !== '') {
    return message
  }

  return fallback
}
